import { isEqual } from 'lodash';
import { DreamValue } from '@typedream/core';
import updateJSON from './updateJSON';

const isContentEqualNoID = (a: DreamValue, b: DreamValue): boolean => {
  const isAContainingNaN = !isEqual(a, a);
  const isBContainingNaN = !isEqual(b, b);
  if (isAContainingNaN || isBContainingNaN) {
    throw new Error('Content contains NaN');
  }

  let aChildren = { ...a?.[0] } as any;
  let bChildren = { ...b?.[0] } as any;

  aChildren = updateJSON({
    id: undefined,
    openOptions: undefined,
  })(aChildren);

  bChildren = updateJSON({
    id: undefined,
    openOptions: undefined,
  })(bChildren);

  return isEqual(aChildren, bChildren);
};

export default isContentEqualNoID;
